module.exports = __webpack_public_path__ + "static/media/partitions_material_60y_y.5a7d8433.csv";